<div class="smooth-scrolling">
  <app-responsive-searchbar></app-responsive-searchbar>

  <!-- big-pg-title START -->
  <div class="big-pg-title">
    <div class="container">
      <div class="sml-title">Our</div>
      <h1>Community</h1>
    </div>
  </div>
  <!-- big-pg-title END -->

  <!-- imgWith-content START -->
  <section class="imgWith-content">
    <div class="container">
      <div class="row align-items-center">

        <div class="col-md-6 col-lg-7 img-blk">
          <figure>
            <img src="assets/images/foy-routine-img.jpg" />
          </figure>
        </div>

        <div class="col-md-6 col-lg-5 desc-blk">
          <div class="desc-wrap">
            <div class="heading">
              <h2>Share Your #foyRoutine</h2>
            </div>
            <p>A #RareRoutine celebrates the belief that there isn't just one way to wear makeup. It's all about the
              freedom to choose how you look each day—without pressure to look like anyone else. Your #RareRoutine is as
              unique as you make it.</p>
            <p>Share your #RareRoutine with the community on social and be sure to tag @rarebeauty for a chance to be
              featured in our gallery—and on our Instagram!</p>
          </div>
        </div>

      </div>
    </div>
  </section>
  <!-- imgWith-content END -->

  <!-- your-community START -->
  <section class="your-community">
    <div class="y-comm-wrap">
      <div class="row align-items-center">
        <div class="col-md-2 leftSide">
          <div class="heading">
            <h2>This is Your Community</h2>
            <p>Share your #foyRoutine and tag @foyforyou for a chance to be featured!</p>
          </div>
        </div>
        <div class="col-md-10 rightSide">
          <div class="splide js_slides community-slides">
            <div class="splide__track">
              <div class="splide__list">
                <div class="item splide__slide style-01">
                  <div class="img01">
                    <figure><img src="assets/images/comm-08.jpg" /><span class="has-tag">@makeupbykenyaa</span></figure>
                  </div>
                  <div class="img02">
                    <figure><img src="assets/images/comm-07.jpg" /><span class="has-tag">kamaa_5</span></figure>
                  </div>
                </div>
                <div class="item splide__slide style-02">
                  <div class="img01">
                    <figure><img src="assets/images/comm-05.jpg" /><span class="has-tag">lilysloveofmakeup</span>
                    </figure>
                  </div>
                </div>

                <div class="item splide__slide style-03">
                  <div class="img01">
                    <figure><img src="assets/images/comm-02.jpg" /><span class="has-tag">glambyfnda</span></figure>
                  </div>
                  <div class="img02">
                    <figure><img src="assets/images/comm-06.jpg" /><span class="has-tag">emanuelmua</span></figure>
                  </div>
                </div>
                <div class="item splide__slide style-04">
                  <div class="img01">
                    <figure><img src="assets/images/comm-03.jpg" /><span class="has-tag">@beautyalyssarose</span>
                    </figure>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- your-community END -->

  <!-- Footer START -->
  <app-footer></app-footer>

  <!-- Footer END -->
</div>